<template>
    <div>
        <div class="content-header">
            <h3>查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                     :size="GCONFIG.styleElFormSize">
              <el-form-item label="话述">
                <el-input v-model="formInline.contactName" placeholder="话述"></el-input>
              </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button type="success" @click="add()">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="pageList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="40"></el-table-column>
<!--                <el-table-column prop="id" label="ID" ></el-table-column>-->
                <el-table-column prop="userAllWords" label="话述" ></el-table-column>
                <el-table-column prop="userKeyWords" label="关键词" ></el-table-column>
              <el-table-column prop="userClass" label="用户分类"   ></el-table-column>
              <el-table-column prop="createUser" label="创建人"  ></el-table-column>
              <el-table-column prop="createTime" label="创建时间" ></el-table-column>
              <el-table-column prop="status" label="状态" :formatter="statusShow"  ></el-table-column>

              <el-table-column label="操作" fixed="right">
                  <template slot-scope="scope">
                      <el-button-group>
                          <el-button type="primary" size="mini" @click="editData(scope.row)">编辑</el-button>
                      </el-button-group>
                  </template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getWordsPageList} from "../../api/api";
    export default {
        data() {

            return {
                pageList:[],
                formInline: {
                    userAllWords:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0
                },
                showDialog: false,
                showPreviewDialog: false,
                loading: true,
                statusData:[{id:1,name:"可用"},{id:0,name:"禁用"}],
                params:{},


            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据

          this.getList();



        },
        methods: {

            add(){
                //添加
                this.$router.push({
                    path: 'wordsEdit',
                    name: 'wordsEdit',
                    query: {
                        id:'',
                    }
                })
            },
            editData(row){
                this.$router.push({
                    path: 'wordsEdit',
                    name: 'wordsEdit',
                    query: {
                        id:row.id,

                    }
                })
            },
          statusShow(row, column, cellValue) {
            for(var key in this.statusData){
              if(this.statusData[key].id==cellValue) {
                return this.statusData[key].name;
              }
            }
            //return this.randData.name;

          },
            getList(){
                this.loading = true;
              getWordsPageList(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.pageList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },



            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },

            reset(formName){
                this.$refs[formName].resetFields();
            },

            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .customer-detail-order {
        .customer-nick {
            margin: 0;
        }
        .el-table th {
            background: #f1f1f1;
            color: #222222;
        }
        .el-table__expanded-cell {
            background: #f5f5f5;
            text-align: left;
            padding: 7px 50px;
        }
        .el-table__expanded-cell:hover {
            background: #f5f5f5 !important;
        }
        .expand-title {
            width: 70px;
            color: #444548;
            line-height: 30px;
            text-align: right;
            margin-right: 10px;
            font-weight: 600;
        }
        .expand-flex, .expand-flex-con {
            justify-content: flex-start;
            align-items: center;
            align-content: center;
        }
        .expand-flex-con {
            display: flex;
            flex-wrap: wrap;
            .expand-content {
                margin: 5px 10px 5px 0;
            }
        }
        .el-table__expand-icon > .el-icon {
            font-size: 16px;
            font-weight: bolder;
        }
        .el-divider--horizontal {
            margin: 10px 0;
        }
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/views/distribution/wordsList.vue